module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "clearable": "",
      "prepend-icon": "search",
      "label": "Search"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.search = ''
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.expandAll = !_vm.expandAll
      }
    }
  }, [_c('v-icon', [_vm._v("library_add")])], 1)], 1), _vm._v(" "), _c('v-treeview', {
    ref: "producttree",
    attrs: {
      "selectable": "",
      "open-on-click": "",
      "multiple-active": "",
      "search": _vm.search,
      "filter": _vm.filter,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n      " + _vm._s(item.name) + "\n      "), (item.archived === true) ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "warning"
          }
        }, [_vm._v("archived")]) : _vm._e(), _vm._v(" "), (item.active === false) ? _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "dark": "",
            "color": "warning"
          }
        }, [_vm._v("deactivated")]) : _vm._e()]
      }
    }, {
      key: "append",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.locations), function(location) {
          return _c('v-chip', {
            key: ((item.id) + "-" + (location.id)),
            staticClass: "v-chip--x-small",
            attrs: {
              "outline": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("place")]), _vm._v("\n          " + _vm._s(location.name))], 1)
        })
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00dae902","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/ProductTreePicker.vue
// module id = 1570
// module chunks = 0 1